/*
  beta环境配置
*/
export default  {
    ssoServiceUser: 'http://itsmops-beta.autoai.com/usercenter/sso/operator/www/v1/', // 用户登录
    ssoService: 'http://wedof-beta.autoai.com/', // 用户验证码和key
    baseURL:"http://itsmops-beta.autoai.com/itsm/v1/",      // 业务接口
    roleUrl:"http://wedof-auth-beta.autoai.com/", // 新权限
    BASEURL:"http://itsmops-beta.autoai.com/",         //CICD关联
    BASE_API: 'http://itsmops-beta.autoai.com/',       // 上传
    sseurl:"http://itsmops-beta.autoai.com/itsm/stream",
    // sseurl:"http://itsmops-beta.autoai.com/stream",
    AuthUrl:"http://wedof-auth-beta.autoai.com/authority/v1/",
    manageUrl: 'http://wedof-auth-beta.autoai.com/authority/',
    filterUser:'http://wedof.autoai.com/',//搜索人员接口域名
    timeout: 30000,
    withCredentials: true,
    pageTitle: 'vue管理系统后台模版',
};
